import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3064d0e6")

_pushScopeId("data-v-3064d0e6")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("figure", null, [
  /*#__PURE__*/_createVNode("p", { class: "-bold" }, [
    /*#__PURE__*/_createTextVNode(" 지금 까지와 다른 진료,"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 조금 특별한 비대면 진료 HESEL ")
  ]),
  /*#__PURE__*/_createVNode("img", {
    class: "desktop",
    src: "/images/new/home.png"
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "mobile",
    src: "/images/new/home_m.png"
  })
], -1)
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OnlineCareIntro = _resolveComponent("OnlineCareIntro")
  const _component_SecondOpinionIntro = _resolveComponent("SecondOpinionIntro")
  const _directive_scrollIcon = _resolveDirective("scrollIcon")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _hoisted_3,
      _createVNode("section", _hoisted_4, [
        _createVNode(_component_OnlineCareIntro, {
          class: "onlinecare-intro",
          linkPath: _ctx.RouterName.ONLINE_CARE
        }, null, 8, ["linkPath"]),
        _hoisted_5,
        _createVNode(_component_SecondOpinionIntro, {
          class: "secondopinion-intro",
          linkPath: _ctx.RouterName.SECOND_OPINION
        }, null, 8, ["linkPath"])
      ])
    ])
  ], 512)), [
    [_directive_scrollIcon]
  ])
})